import ExamExperienceIcon from 'img/icons/offering_icons/examexperience_icon.svg';
import { ExamStatus } from 'types/exam';
import {
  BodyRowType,
  HeaderIconConfig,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';
import {
  formatExamExperienceQuotaRows,
  formatExamStatusRows,
} from '../BodyBuilder/utils';

const examExperienceIconConfig: HeaderIconConfig = {
  backgroundColor: '#2274A5',
  iconTitle: 'Delivery format: Exam Experience',
  src: ExamExperienceIcon,
};

const examExperienceConfig: OfferingTypeConfig = {
  actionButtons: ({ displayProgress, entry, catalogStore, t }) => {
    const link = catalogStore.getCatalogEntryLink(entry);
    if (!link) {
      return {};
    }

    return {
      actionButtonA: {
        buttonLabel: displayProgress ? t('Continue') : t('View'),
        href: link.href,
        icon: IconType.Arrow,
        onClick: link.navigate,
      },
    };
  },
  bodyRowsLayout: () => [BodyRowType.Custom],
  buildCustomRows: ({ examExperienceQuota, examStatusInfo, t }) => {
    if (examStatusInfo?.status !== ExamStatus.Unenrolled)
      return formatExamStatusRows(examStatusInfo, t);
    return formatExamExperienceQuotaRows(examExperienceQuota);
  },
  headerConfig: ({ t }) => ({
    iconB: examExperienceIconConfig,
    title: t('Exam experience'),
  }),
};

export default examExperienceConfig;
